/**
* Hero Content Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Content Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-content-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.hero-content-banner' ).each( function( key, val ) {
        let image = $( this ).find( '.fit-image img' )[0];
        if ( $( this ).find( '.loop-video-container' ).length ) {
          image = $( this ).find( '.loop-video-container' )[0];
        }
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom top',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( image, {y: '10%', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-content-banner', COMPONENT );
} )( app );
